import { Stack } from '@mui/material';
import classNames from 'classnames';
import { Props } from './types';

export const GameTimer = ({
  timerOn,
  scoreType,
  progressOn,
  locks,
  gameTime,
  username,
  gamePoints,
  hasClientLogo,
}: Props) => {
  // currentTime: number = 1403, currentProgress: number = 1, locksCount: number = 10
  const time = new Date(gameTime).toISOString().substr(11, 8);
  const progress = `${gamePoints} / ${locks?.reduce((acc, lock) => {
    return acc + (lock?.point || 0);
  }, 0)}`;

  return (
    <div className={classNames('game-tour-timer', hasClientLogo && 'game-tour-timer-with-logo')}>
      {username && (
        <Stack direction="row" mx={{ xs: 1, sm: 2 }} gap={1} alignItems="center" flexWrap="wrap">
          <i className="fa-regular fa-user" />
          {username}
        </Stack>
      )}
      {timerOn && (
        <Stack direction="row" mx={{ xs: 1, sm: 2 }} gap={1} alignItems="center" flexWrap="wrap">
          <i className="fa-light fa-clock" />
          <div className="game-timer-time">{time}</div>
        </Stack>
      )}
      {progressOn && (
        <Stack direction="row" mx={{ xs: 1, sm: 2 }} gap={1} alignItems="center" flexWrap="wrap">
          <i className="fa-regular fa-star" />
          <div className="game-timer-progress">
            {scoreType === 'points' ? gamePoints : progress}
          </div>
        </Stack>
      )}
    </div>
  );
};
